<template>
  <v-overlay :value="overlay">
    <v-stepper v-model="e1" light>
      <v-stepper-header>
        <v-stepper-step :complete="e1 > 1" step="1">自己評価</v-stepper-step>

        <v-stepper-step :complete="e1 > 2" step="2">
          プラスの氣
        </v-stepper-step>
        <v-stepper-step step="3">はじめましょう</v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-row>
          <v-stepper-content step="1">
            <v-card>
              <v-img
                src="../../../assets/onboarding-self-check.png"
                width="350"
              />
              <v-card-text>
                <h1>自己評価</h1>
                <p class="my-2">
                  期間内の目標に対する自己評価の入力が可能です。
                </p>
              </v-card-text>
              <v-card-actions>
                <Button @click="e1 = 2" color="info">次へ</Button>
              </v-card-actions>
            </v-card>
          </v-stepper-content>

          <v-stepper-content step="2">
            <v-card>
              <v-img
                src="../../../assets/onboarding-encouragements.png"
                width="350"
              />
              <v-card-text>
                <h1>プラスの氣</h1>
                <p class="my-2">
                  行動や目標に対する取り組みに対しメッセージを送り合うことができます<br />
                  スタッフの取り組みやがんばりを共有し、モチベーションアップや評価基準に繋げることができます
                </p>
              </v-card-text>
              <v-card-actions>
                <Button @click="e1 = 3" color="info">次へ</Button>
                <Button @click="e1 = 1" color="secondary">戻る</Button>
              </v-card-actions>
            </v-card>
          </v-stepper-content>

          <v-stepper-content step="3">
            <v-card>
              <v-img src="../../../assets/onboarding-success.svg" width="350" />
              <v-card-text>
                <h1>はじめましょう</h1>
                <p class="my-2">
                  それでは以下の完了ボタンを押して、Hitonobiのサービスをはじめましょう。
                </p>
              </v-card-text>
              <v-card-actions>
                <Button @click="onClick($event)" color="primary">完了</Button>
                <Button @click="e1 = 2" color="secondary">戻る</Button>
              </v-card-actions>
            </v-card>
          </v-stepper-content>
        </v-row>
      </v-stepper-items>
    </v-stepper>
  </v-overlay>
</template>

<script>
export default {
  name: 'OnboardingJunior',

  props: {
    overlay: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      e1: 1,
      absolute: true,
    };
  },

  methods: {
    onClick(event) {
      this.$emit('click', event);
    },
  },
};
</script>
